(function () {
  function setFill(el) {
    var target = getComputedStyle(el).getPropertyValue('--fsb-progress').trim();
    el.style.width = target || '0%';
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var fills = node.classList && node.classList.contains('fsb__fill')
          ? [node]
          : Array.from(node.querySelectorAll ? node.querySelectorAll('.fsb__fill') : []);
        fills.forEach(setFill);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.fsb__fill').forEach(setFill);
  });
})();
